import { Component, ErrorInfo } from 'react'
import logger from '../../core/logger/Logger'
import DefaultError from './error_pages/DefaultError'

interface Props {
    children: JSX.Element | JSX.Element[]
    renderError?: (error: Error) => JSX.Element
}

interface State {
    hasError: boolean
    error: Error | null
}

class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        error: null
    }

    public static getDerivedStateFromError(error: Error): State {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error }
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        logger.error(error)
        if (errorInfo && errorInfo.componentStack) logger.log('ERROR component stack: ' + errorInfo?.componentStack)
        this.setState({ error })
    }

    public render() {
        if (this.state.hasError) {
            if (this.props.renderError) {
                return this.props.renderError(this.state.error)
            } else {
                return <DefaultError error={this.state.error} />
            }
        }

        return this.props.children
    }
}

export default ErrorBoundary
